import React, { useState } from 'react';
import InfiniteList from '../../homePage/InfiniteList';
import TabButton from './TabButton';
import Button from 'components/v2/button/Button';

type Event = {
  id: string;
  title: string;
  subtitle?: string;
  time: string;
};

type Tab = 'recommended' | 'following';

const mockEvents: Event[] = [
  {
    id: '1',
    title: 'Grab Dinner with Juliann Today',
    time: '6PM',
  },
  {
    id: '2',
    title: 'Pickup Basketball with Mike, Jane and Sara Saturday',
    time: '2pm',
    subtitle: 'Everyone is free!',
  },
  {
    id: '3',
    title: 'D&D with John and Louis again 12/30',
    time: '3pm EST',
    subtitle: 'Do it again!',
  },
];

const AIEventsSection: React.FC = () => {
  const [activeTab, setActiveTab] = useState<Tab>('recommended');
  const [events] = useState<Event[]>(mockEvents);

  const loadMore = () => {
    console.log('Loading more events...');
  };

  return (
    <div className="mt-8 px-5">
      <div className="flex justify-center gap-x-8 mb-14 relative z-10">
        <div className="absolute -bottom-[20px] h-[1px] bg-white/30 w-[200px]"></div>

        <div className="relative flex items-center gap-x-8">
          <TabButton
            isActive={activeTab === 'recommended'}
            onClick={() => setActiveTab('recommended')}
          >
            Recommended
          </TabButton>

          <TabButton
            isActive={activeTab === 'following'}
            onClick={() => setActiveTab('following')}
          >
            Following
          </TabButton>

          <div className="absolute bottom-[-20px] h-[1px] w-full bg-transparent">
            <div
              className="h-full bg-white transition-all duration-300"
              style={{
                width: activeTab === 'recommended' ? '120px' : '80px',
                position: 'absolute',
                left: activeTab === 'recommended' ? '0' : '120px',
              }}
            />
          </div>
        </div>
      </div>

      <InfiniteList onInView={loadMore}>
        <div className="h-full">
          <div className="space-y-4 overflow-y-scroll max-h-[calc(50svh-10rem)]">
            {activeTab === 'recommended' &&
              events.map((event) => (
                <div
                  key={event.id}
                  className="bg-[#110E2B] rounded-2xl p-6 flex justify-between items-center max-h-[120px]"
                >
                  <div>
                    <h3 className="text-base font-semibold text-white mb-2">
                      {event.title} at {event.time}
                    </h3>
                    {event.subtitle && (
                      <p className="text-white/80 text-xs font-light">
                        {event.subtitle}
                      </p>
                    )}
                  </div>
                  <button className="bg-[#6000E9] text-white px-6 py-3 rounded-full whitespace-nowrap text-xs font-medium">
                    Let's hang
                  </button>
                </div>
              ))}
            {activeTab === 'following' &&
              events.map((event) => (
                <div
                  key={event.id}
                  className="bg-[#110E2B] rounded-2xl p-6 flex justify-between items-center max-h-[120px]"
                >
                  <div>
                    <div>
                      <h3 className="text-base font-semibold text-white mb-2">
                        {event.title} at {event.time}
                      </h3>
                    </div>
                    <div className="flex items-center gap-x-2">
                      {event.subtitle && (
                        <p className="text-white/80 text-xs font-light">
                          {event.subtitle}
                        </p>
                      )}
                      <Button className="w-fit px-5 py-2" variant="secondary">
                        Join
                      </Button>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </InfiniteList>
    </div>
  );
};

export default AIEventsSection;
